import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { filtrarMetodosConfiguracion } from '../../actions/configuracion';
import { filtrarVentasDetalle, generarVentasDetalle } from '../../actions/reportes';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const FiltrosVentasDetalle = () => {

    const dispatch =  useDispatch();

    const { ventana_filtros_ventas_detalle } = useSelector(state => state.reportes);
    const { listado: listado_metodos } = useSelector(state => state.configuracion.metodos);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [filtrosData, setFiltrosData] = useState({
        fecha_inicio: null,
        fecha_fin: null
    });

    const [columnasData, setColumnasData] = useState([]);
    const columnasEstaticas = [
        { value: 'fecha', label: 'Fecha' },
        { value: 'hora', label: 'Hora' },
        { value: 'cliente', label: 'Cliente' },
        { value: 'pacientes', label: 'Pacientes' },
        { value: 'total', label: 'Total' }
    ];
    const [columnasFilter, setColumnasFilter] = useState(columnasEstaticas);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible",
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Filtros */
    const handleAbrir = () => {
        dispatch(filtrarMetodosConfiguracion(4));
    }

    const handleDatePicker = (name, value) => {
        setFiltrosData({
            ...filtrosData,
            [name]: value
        });
    }

    const handleProcesar = async (limpiar) => {
        await setStatusProcesar(true);

        if(!limpiar){
            await dispatch(generarVentasDetalle({
                ...filtrosData,
                columnas: columnasData.map(c => c.value)
            }));

            await handleCerrar();
        }else{
            let datos_base = {
                ...filtrosData,
                fecha_inicio: null,
                fecha_fin: null
            };

            await setFiltrosData(datos_base);
            await setColumnasData([]);
        }

        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setFiltrosData({
                fecha_inicio: null,
                fecha_fin: null
            });

            setColumnasData([]);

            dispatch(filtrarVentasDetalle(false));
        }
    }

    useEffect(() => {
        let dinamicas = listado_metodos.map(m => ({ value: `metodo_${m.id}`, label: m.nombre }));
        setColumnasFilter([...columnasEstaticas, ...dinamicas]);
    }, [listado_metodos]);

    return (
        <Modal show={ventana_filtros_ventas_detalle} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Reporte de ventas</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="columnas"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Columnas a incluir (vacío = todas)"
                                options={columnasFilter}
                                value={columnasData}
                                isClearable={true}
                                isMulti={true}
                                onChange={(value) => setColumnasData(value || [])}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_inicio ? new Date(filtrosData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha inicial</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_fin ? new Date(filtrosData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha final</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-secondary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-secondary" onClick={() => handleProcesar(true)}><i className="fas fa-trash fa-sm"></i> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-search fa-sm"></i> Buscar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosVentasDetalle;
